import { ERROR, LOGIN_ERROR, LOGIN_SUCCESS, SET_EMAIL, SET_PASSWORD, SET_USER, SUCCESS } from "../types";

const initialState = {
    username: "",
    password: "",
    status: "",
    token: null, 
};

const loginReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_EMAIL:
            return {
                ...state,
                username: action.payload,
            };
        case SET_PASSWORD:
            return {
                ...state,
                password: action.payload,
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                status: SUCCESS,
            };
        case LOGIN_ERROR:
            return {
                ...state,
                status: ERROR,
            };
        case SET_USER: 
            return {
                ...state,
                token: action.payload.token, 
            };
        default:
            return state;    
    }
};

export default loginReducer;
